var exports = {
  "Du": "authorAvatar__aotVQj",
  "WJ": "committerAvatar__xwdAIh",
  "fh": "authorName__W_50mz",
  "Ax": "commitAuthors__XmHs7a",
  "ft": "peopleCount__z9WJsN",
};

module.exports = exports;
